import {
    SelectDateAction,
    SelectLocationAction,
    SelectTimeAction,
    SelectProviderAction,
    SelectCityAction,
    SetFirstNameAction,
    SetLastNameAction,
    SetClientIdAction,
} from '../redux/types';
import { Provider } from './types';

export interface BookingActions {
    selectCity: (cityId: string) => SelectCityAction;
    selectDate: (date: string) => SelectDateAction;
    selectLocation: (locationId: string) => SelectLocationAction;
    selectTime: (time: string) => SelectTimeAction;
    selectProvider: (provider: Provider | null) => SelectProviderAction;
    setFirstName: (firstName: string) => SetFirstNameAction;
    setLastName: (lastName: string) => SetLastNameAction;
    setClientId: (clientId: string) => SetClientIdAction;
}

let loading: Promise<BookingActions>;

export default function load(): Promise<BookingActions> {
    if (!loading) {
        loading = new Promise((resolvePromise) => {
            import('booking/redux/actions').then(
                ({
                    selectCity,
                    selectDate,
                    selectLocation,
                    selectTime,
                    selectProvider,
                    setFirstName,
                    setLastName,
                    setClientId,
                }) => {
                    resolvePromise({
                        selectCity,
                        selectDate,
                        selectLocation,
                        selectTime,
                        selectProvider,
                        setFirstName,
                        setLastName,
                        setClientId,
                    });
                },
            );
        });
    }

    return loading;
}
